<div class="modal">
  <div class="modal-header">
    <div class="modal-header--left">
      <div class="invoice-date">
        Створена: {{ invoice.CreationDate | np_to_date_format | date :"dd.MM.yyyy HH:mm:ss" }}
      </div>
      <div class="invoice-number--wrapper">
        <mat-icon class="material-icons invoice-header__icon-type invoice-number--icon">content_paste</mat-icon>
        <div class="invoice-number--value">
          <div class="invoice-header__number copy-content copy-content_lg">
          <span>
            {{ (invoice?.Number | fineDocNumber) || '—' }}
          </span>
            <button mat-icon-button class="copy-content__btn"
                    [appCopy]="invoice?.Number"
                    [matTooltip]="'Скопіювати'"
                    matTooltipPosition="below">
              <mat-icon class="material-icons_grey copy-content__icon">file_copy</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-header--right">
      <div class="modal-header--right-column">
        <div class="modal-header--right-column-label">
          Опис відправлення
        </div>
        <div class="modal-header--right-column-value">
          {{ invoice.CargoDescription || '—' }}
        </div>
      </div>
      <div class="modal-header--right-column">
        <div class="modal-header--right-column-label">
          Оголошена вартість
        </div>
        <div class="modal-header--right-column-value">
          {{ invoice?.Cost | fineNumber }} {{ invoice?.CurrencyCode }}
        </div>
      </div>
    </div>
    <span class="modal-close" (click)="close()">
      <i class="material-icons">close</i>
    </span>
  </div>
  <div class="modal-content">
    <mat-progress-bar mode="indeterminate" [style.opacity]="+isLoadingVisible"></mat-progress-bar>
    <div class="modal-content-row">
      <div class="modal-content--left">
        <div class="invoice-state"
             [ngClass]="'invoice-state-2'">
          <div class="invoice-state__progress"
               [npInvoiceProgress]="'2'">
          </div>
          <div class="invoice-state__startpoint">
            Дата виїзду:
            <ng-container *ngIf="invoice?.DateTime; else dash">
              {{ invoice?.CreationDate | np_to_date_format| date :"dd.MM.yyyy" }}
            </ng-container>
            <div class="invoice-state__startpoint-location">
              <ng-container *ngIf="SenderAddress; else dash">
                {{ SenderAddress }}
              </ng-container>
            </div>
          </div>
          <div class="invoice-state__name invoice-state-1__color">
            <div class="invoice-state__name--chip">
              <div class="invoice-state__name--chip-container">
                <mat-icon class="invoice-state__name--chip-icon">schedule</mat-icon>
                Нова пошта очікує надходження від відправника
              </div>
            </div>
          </div>
          <div class="invoice-state__endpoint">
            <div class="invoice-state__endpoint-banner">
              <div class="invoice-state__endpoint-banner-container">
                <mat-icon class="invoice-state__endpoint-banner-icon">info_outline</mat-icon>
                Дата доставки стане доступною після відправлення
              </div>
            </div>
            {{ RecipientAddress }}
          </div>
        </div>
      </div>
      <div class="modal-content--right modal-content--right-col">
        <div class="info-cell">
          <div class="info-cell--label">
            Отримувач
          </div>
          <div class="info-cell--value">
            {{ Recipient }}
          </div>
        </div>
        <div class="info-cell">
          <div class="info-cell--label">
            Телефон отримувача
          </div>
          <div class="info-cell--value">
            +{{ invoice.PhoneRecipient }}
          </div>
        </div>
      </div>
    </div>
    <div class="modal-content-row">
      <div class="modal-content--left-row">
        <div class="info-cell">
          <div class="info-cell--label">
            Вартість доставки
          </div>
          <div class="info-cell--value-lg">
            <ng-container *ngIf="!isPaid; else paidTemplate">
              {{ (invoice.DocumentCost) + ' грн' }}
            </ng-container>

            <ng-template #paidTemplate>
              <span class="line-through-text">
                {{ (invoice.DocumentCost) + ' грн' }}
              </span>
              Сплачено
            </ng-template>
          </div>
        </div>
        <div class="info-cell">
          <div class="info-cell--label">
            Платник за доставку
          </div>
          <div class="info-cell--value">
            {{ Payer }}
          </div>
        </div>
      </div>

      <div class="modal-content--right-row">
        <div class="info-cell">
          <div class="info-cell--label">
            Форма оплати за доставку
          </div>
          <div class="info-cell--value">
            {{ PaymentMethod }}
          </div>
        </div>
        <div class="info-cell">
          <button *ngIf="isPaymentButtonVisible" class="mat-button_sm mat-button_uppercase invoice__payment-btn"
                  color="primary"
                  mat-raised-button
                  [matTooltip]="payButtonTooltip"
                  [disabled]="isPaymentDisabled || isPaymentPending"
                  (click)="pay()">
            Сплатити
          </button>
          <button *ngIf="isPaymentCancelButtonVisible" class="mat-button_sm mat-button_uppercase invoice__payment-btn"
                  color="primary"
                  mat-raised-button
                  [disabled]="isCancelPaymentPending"
                  (click)="cancelPayment()">
            Відміна оплати
          </button>
        </div>
      </div>
    </div>
    <div class="modal-content-row" *ngIf="isShowFull">
      <div class="modal-content--left-row">
        <div class="info-cell--row">
          <div class="info-cell">
            <div class="info-cell--label">
              Тип
            </div>
            <div class="info-cell--value">
              {{ invoice.TypeOfShipmentDescription || '&mdash;' }}
            </div>
          </div>
          <div class="info-cell">
            <div class="info-cell--label">
              Вага
            </div>
            <div class="info-cell--value">
              {{ (invoice.Weight ? invoice.Weight + ' кг' : '') || '&mdash;' }}
            </div>
          </div>
        </div>
        <div class="info-cell--row">
          <div class="info-cell">
            <div class="info-cell--label">
              Обʼємна вага
            </div>
            <div class="info-cell--value">
              {{ (invoice.VolumetricWeight ? invoice.VolumetricWeight + ' кг' : '') || '&mdash;' }}
            </div>
          </div>
          <div class="info-cell">
            <div class="info-cell--label">
              Місць
            </div>
            <div class="info-cell--value">
              {{ invoice.PlacesAmount || '&mdash;' }}
            </div>
          </div>
        </div>
      </div>
      <div class="modal-content--right-row">
        <div class="info-cell">
          <div class="info-cell--label">
            Відправник
          </div>
          <div class="info-cell--value">
            {{ contactPersonSender?.Description }}
          </div>
        </div>
        <div class="info-cell">
          <div class="info-cell--label">
            Телефон відправника
          </div>
          <div class="info-cell--value">
            {{ '+' + invoice.PhoneSender }}
          </div>
        </div>
        <div *ngIf="false" class="info-cell">
          <div class="info-cell--label">
            Компанія
          </div>
          <div class="info-cell--value">
            Sender
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="modal-footer--left">
      <button type="button"
              class="mat-button_with-icon"
              [disableRipple]="true"
              (click)="switchShowFull()"
              mat-button>
        <mat-icon *ngIf="!isShowFull"
                  class="material-icons_grey button-more__icon">keyboard_arrow_down
        </mat-icon>
        <mat-icon *ngIf="isShowFull"
                  class="material-icons_grey button-more__icon">keyboard_arrow_up
        </mat-icon>
        {{ !isShowFull ? 'Показати більше' : 'Приховати' }}
      </button>
    </div>
    <div class="modal-footer--right">
      <span [matTooltip]="deleteDisabled ? 'Видалення доступне лише за відсутності оплати' : null">
        <button mat-button
                [matTooltip]="!deleteDisabled ? 'Видалити' : null"
                [disabled]="deleteDisabled"
                [confirmMsg]="'Ви справді хочете видалити цю посилку?'"
                [confirmBtnText]="'Видалити'"
                [cancelBtnText]="'Скасувати'"
                (confirm)="remove(invoice)">
          <mat-icon>delete</mat-icon>
        </button>
      </span>
      <button mat-button
              *ngIf="!invoice.ScanSheetRef && !invoice?.ScanSheetNumber"
              (click)="addToRegister()"
              matTooltip="Додати до реєстру"
              matTooltipPosition="below"
        >
        <mat-icon class="material-icons_grey">add_to_photos</mat-icon>
      </button>
      <button *ngIf="invoice?.ScanSheetNumber"
              (click)="removeSingleFromRegister()"
              matTooltip="Видалити з реєстру"
              matTooltipPosition="below"
              mat-button>
        <mat-icon class="material-icons_grey material-icons_delete-sweep fz-28">delete_sweep</mat-icon>
      </button>
      <button mat-button
              matTooltipPosition="below"
              matTooltip="Дублювати"
              (click)="duplicate(invoice)">
        <mat-icon class="material-icons_grey">
          file_copy
        </mat-icon>
      </button>
      <button mat-button [matMenuTriggerFor]="printMenu">
        <mat-icon class="material-icons_grey" matTooltip="Друкувати">print</mat-icon>
      </button>
      <mat-menu #printMenu="matMenu" class="mat-menu_width_3">
        <button mat-menu-item (click)="print(PRINT_FORMS.INTERNATIONAL_MARKING)">
          Міжнародні документи, 2 копiї
        </button>
        <div [matTooltip]="printZebraTooltip"
             matTooltipPosition="before">
          <button [disabled]="!isZebraPrintAvailable(invoice?.State)"
                  mat-menu-item
                  (click)="print(PRINT_FORMS.MARKING_5)">
            Маркування 100*100 типу “зебра”, PDF
          </button>
        </div>
      </mat-menu>
      <span [matTooltip]="editDisabled ? 'Редагування доступне лише за відсутності оплати' : null">
        <button mat-button
                [disabled]="editDisabled"
                matTooltipPosition="below"
                [matTooltip]="!editDisabled ? 'Редагувати' : null"
                (click)="edit(invoice)">
          <mat-icon>mode_edit</mat-icon>
          Редагувати
        </button>
      </span>
  </div>
</div>
<ng-template #dash>—</ng-template>
